export default {"src":"/_next/static/media/calendarFour_40.5b5d1384.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};